import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../../theme/css/theme.css";

export const rowStyle = recipe({
  variants: {
    isError: {
      true: {
        borderColor: theme.colors.error,
        vars: {
          "--border-color": `${theme.colors.error} !important`,
        },
      },
    },
  },
});

export const contentStyle = style({
  alignItems: "center",
  flexDirection: "row",
  paddingLeft: theme.spacings.s,
  minHeight: rem(52),
});

export const stepsContainerStyle = style({
  padding: `${theme.spacings.xs} ${theme.spacings.s}`,
  backgroundColor: theme.colors.backgroundShade,
  borderRadius: theme.borderRadiuses.xs,
  gap: theme.spacings.xxs,
});
